import { render, staticRenderFns } from "./GoliaSidebar.vue?vue&type=template&id=d1347310&scoped=true"
import script from "./GoliaSidebar.vue?vue&type=script&lang=js"
export * from "./GoliaSidebar.vue?vue&type=script&lang=js"
import style0 from "./GoliaSidebar.vue?vue&type=style&index=0&id=d1347310&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1347310",
  null
  
)

export default component.exports